/* Copyright 2013 - 2024 Waiterio LLC */
import supovia from './supovia.json' with { type: 'json' }

export default supovia.websiteId
